// icon-configs.js

export const iconConfigs = {
  base: {
    size: "1x",
    color: "inherit",
  },
  small: {
    size: "xs",
    color: "inherit",
  },
  large: {
    size: "lg",
    color: "inherit",
  },
  primary: {
    size: "1x",
    color: "#007bff", // Exemplo de cor primária
  },
  secondary: {
    size: "1x",
    color: "#6c757d", // Exemplo de cor secundária
  },
  success: {
    size: "1x",
    color: "#28a745", // Exemplo de cor de sucesso
  },
  danger: {
    size: "1x",
    color: "#dc3545", // Exemplo de cor de perigo
  },
  warning: {
    size: "1x",
    color: "#ffc107", // Exemplo de cor de aviso
  },
  info: {
    size: "1x",
    color: "#17a2b8", // Exemplo de cor de informação
  },
  light: {
    size: "1x",
    color: "#f8f9fa", // Exemplo de cor clara
  },
  dark: {
    size: "1x",
    color: "#343a40", // Exemplo de cor escura
  },
  // Estilos adicionais baseados na documentação do FontAwesome
  extraSmall: {
    size: "xs",
    color: "inherit",
  },
  medium: {
    size: "2x",
    color: "inherit",
  },
  extraLarge: {
    size: "3x",
    color: "inherit",
  },
  // Estilos de rotação
  rotate90: {
    size: "1x",
    color: "inherit",
    rotation: 90,
  },
  rotate180: {
    size: "1x",
    color: "inherit",
    rotation: 180,
  },
  rotate270: {
    size: "1x",
    color: "inherit",
    rotation: 270,
  },
  // Estilos de animação
  spin: {
    size: "1x",
    color: "inherit",
    spin: true,
  },
  pulse: {
    size: "1x",
    color: "inherit",
    pulse: true,
  },
  // Estilos de borda
  bordered: {
    size: "1x",
    color: "inherit",
    border: true,
  },
  // Estilos de inversão
  inverse: {
    size: "1x",
    color: "inherit",
    inverse: true,
  },
  // Estilos de pull
  pullLeft: {
    size: "1x",
    color: "inherit",
    pull: "left",
  },
  pullRight: {
    size: "1x",
    color: "inherit",
    pull: "right",
  },
  // Estilos de menu
  menuAside: {
    size: "lg",
    color: "inherit",
  },
};
